// MARK://dhk8/admin-shell/components/TaxRatePicker
// Tasa de IVA por LISTA (Gustavo 2026-06-23): 0% / 8% (frontera) / 16% o Personalizado,
// en vez de teclear el decimal a mano. El valor se maneja como string decimal
// ('0', '0.08', '0.16', o el personalizado '0.NN') para no romper el contrato actual
// (product.taxRate es decimal string). "Personalizado" abre un input en % entero.
import { useState } from 'react'

const PRESETS: { v: string; label: string }[] = [
  { v: '0', label: '0% (exento / tasa 0)' },
  { v: '0.08', label: '8% (frontera)' },
  { v: '0.16', label: '16% (general)' },
]
const CUSTOM = '__custom__'

function isPreset(v: string): boolean {
  const n = Number.parseFloat(v)
  return PRESETS.some((p) => Math.abs(Number.parseFloat(p.v) - n) < 1e-9)
}
function toPct(v: string): string {
  const n = Number.parseFloat(v)
  return Number.isFinite(n) ? String(Math.round(n * 10000) / 100) : ''
}

interface TaxRatePickerProps {
  value: string
  onChange: (decimal: string) => void
  label?: string
}

export default function TaxRatePicker({ value, onChange, label = 'Tasa de IVA' }: TaxRatePickerProps) {
  const [custom, setCustom] = useState(value !== '' && !isPreset(value))

  return (
    <label className="adm-field">
      <span className="adm-field__label">{label}</span>
      <select
        className="adm-select"
        value={custom ? CUSTOM : (isPreset(value) ? String(Number.parseFloat(value)) : '')}
        onChange={(e) => {
          if (e.target.value === CUSTOM) { setCustom(true); return }
          setCustom(false)
          onChange(e.target.value)
        }}
      >
        {value === '' && <option value="">— Selecciona tasa —</option>}
        {PRESETS.map((p) => <option key={p.v} value={String(Number.parseFloat(p.v))}>{p.label}</option>)}
        <option value={CUSTOM}>Personalizado…</option>
      </select>
      {custom && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 6 }}>
          <input
            className="adm-input"
            type="number"
            min={0}
            max={100}
            step="0.01"
            value={toPct(value)}
            onChange={(e) => {
              const pct = Number.parseFloat(e.target.value)
              onChange(Number.isFinite(pct) ? String(Math.round((pct / 100) * 1e6) / 1e6) : '')
            }}
            placeholder="ej. 12"
            aria-label="Tasa de IVA personalizada en porcentaje"
            style={{ maxWidth: 120 }}
          />
          <span className="adm-muted">%</span>
        </div>
      )}
    </label>
  )
}
